import { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const result = useMemo(() => {
    const translations = {
      title: formatMessage(messages.title),
      descriptionStart: formatMessage(messages.descriptionStart),
      descriptionEnd: formatMessage(messages.descriptionEnd),
      btnCancel: formatMessage(messages.btnCancel),
      btnSubmit: formatMessage(messages.btnSubmit),
    };

    return { translations };
  }, [formatMessage]);
  return result;
};
export default useTranslations;
